/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PrimaryPayorTag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PrimaryPayorTag({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/PrimaryPayorTag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let payorIsPrimaryValueData = fromData.useDataValue({ viewPath,
context: 'payor',
path: 'is_primary',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(payorIsPrimaryValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}